const templates = {
    ['Keeper confirmation']: {
        template: require('../../../common/letterTemplates/keeper-confirmation/keeper-confirmation.html')
    },
    ['Dealer confirmation']: {
        template: require('../../../common/letterTemplates/dealer-confirmation/dealer-confirmation.html')
    }
};

export default function ($element, $compile, $scope, close, keepers, keeper, dealers, vehicleId, $filter, createKeeperConfirmationLetter, createDealerConfirmationLetter, toaster) {
    /* --- */

    $scope.model = {};
    $scope.templateNames = Object.keys(templates);
    $scope.selectedTemplate = null;
    $scope.keepers = keepers;
    $scope.dealers = dealers;
    $scope.selectedKeeper = keeper;
    $scope.filter = $filter;
    $scope.vehicleId = vehicleId;
    /* --- */

    $scope.onTemplateSelect = onTemplateSelect;
    $scope.onKeeperChange = onKeeperChange;
    $scope.onDealerChange = onDealerChange;
    $scope.complete = complete;
    $scope.closeModal = close;

    const contentEl = $element.find('content-area');

    /* --- */

    function onTemplateSelect() {
        $scope.model = {};
        changeTemplate($scope.selectedTemplate);

        if ($scope.selectedTemplate === 'Keeper confirmation' &&
            $scope.selectedKeeper) {
            $scope.model = $scope.selectedKeeper;
        }

        if ($scope.selectedTemplate === 'Dealer confirmation' &&
            $scope.selectedDealer) {
            $scope.model = $scope.selectedDealer;
        }
    }

    function onKeeperChange() {
        $scope.selectedKeeperInvalid = false;
        $scope.model = $scope.selectedKeeper;
    }

    function onDealerChange() {
        $scope.selectedDealerInvalid = false;
        $scope.model = $scope.selectedDealer;
    }

    function changeTemplate(templateName) {
        const compiledContent = $compile(templates[templateName].template)($scope);

        contentEl.empty();
        contentEl.append(compiledContent);
    }

    function complete(commType) {
        if (commType === 'Keeper confirmation') {
            if (!$scope.selectedKeeper) {
                $scope.selectedKeeperInvalid = true;
                return;
            }

            $scope.selectedKeeperInvalid = false;

            if ($scope.selectedTemplate === 'Keeper confirmation' &&
                !$scope.displaySaleDate &&
                !$scope.displaySaleMileage &&
                !$scope.displayPurchaseDate &&
                !$scope.displayPurchaseMileage) {
                $scope.displayOptionsInvalid = true;
                return;
            }

            $scope.displayOptionsInvalid = false;

            const payload = {
                displaySaleDate: $scope.displaySaleDate,
                displaySaleMileage: $scope.displaySaleMileage,
                displayPurchaseDate: $scope.displayPurchaseDate,
                displayPurchaseMileage: $scope.displayPurchaseMileage
            };

            createKeeperConfirmationLetter($scope.vehicleId, $scope.selectedKeeper.id, payload)
                .then(() => {
                    close();
                    toaster.pop('success', 'The keeper confirmation letter has been created');
                })
                .catch(() => {
                    toaster.pop('error', 'An error occured when creating an enquiry');
                });
        }

        if (commType === 'Dealer confirmation') {
            if (!$scope.selectedDealer) {
                $scope.selectedDealerInvalid = true;
                return;
            }

            $scope.selectedDealerInvalid = false;

            if ($scope.selectedTemplate === 'Dealer confirmation' &&
                !$scope.v5Document &&
                !$scope.signedForm1 &&
                !$scope.supportingDocuments &&
                !$scope.statedMileage &&
                !$scope.currentVrm &&
                !$scope.fullVin &&
                !$scope.otherVrm) {
                $scope.displayOptionsInvalid = true;
                return;
            }

            $scope.displayOptionsInvalid = false;

            const payload = {
                v5Document: $scope.v5Document,
                signedForm1: $scope.signedForm1,
                supportingDocuments: $scope.supportingDocuments,
                statedMileage: $scope.statedMileage,
                currentVrm: $scope.currentVrm,
                fullVin: $scope.fullVin,
                otherVrms: $scope.otherVrms
            };

            createDealerConfirmationLetter($scope.vehicleId, $scope.selectedDealer.dealerId, $scope.selectedDealer.enquiryId, payload)
                .then(() => {
                    close();
                    toaster.pop('success', 'The dealer confirmation letter has been created');
                })
                .catch(() => {
                    toaster.pop('error', 'An error occured when creating an enquiry');
                });
        }
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/createLetter/createLetterCtrl.js